import moment from 'moment-timezone'

const utcOffsets = moment.tz.names().map(item => {
  return {
    value: item,
    label: item + '(' + moment.tz(item).utcOffset() / 60 + ')'
  }
})

const tagOptions = [
  'Run away line',
  'Non responsive line',
  'Divergence',
  'Disconnected line',
  'Saturated readings',
  'sit/stand inaccuracy',
  'sensor line drop',
  'Unexplained'
]

const pass = 'PASS'
const environments = {
  production: 'Production',
  staging: 'Staging'
}

const baseUrls = {
  baseUrl: 'https://mesh.smartzhealth.com',
  commonBaseUrl: 'https://config.smartzhealth.com/api',
  reportBaseUrl: 'https://app.smartzhealth.com'
}

const allPermissionAccount = 'simavita'

const subscriptionCodeStatus = {
  trial: 'TRIAL',
  approved: 'APPROVED',
  disabled: 'DISABLED'
}

export {
  utcOffsets,
  baseUrls,
  allPermissionAccount,
  tagOptions,
  pass,
  environments,
  subscriptionCodeStatus
}
